import { render } from "./numberVerification.vue?vue&type=template&id=35634657&scoped=true"
import script from "./numberVerification.vue?vue&type=script&lang=js"
export * from "./numberVerification.vue?vue&type=script&lang=js"

import "./numberVerification.vue?vue&type=style&index=0&id=35634657&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35634657"]])

export default __exports__